export default __webpack_public_path__ + "static/media/watts6bar.59df51db.png";